var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 8.00024C16.0002 8.25624 15.9022 8.51224 15.7072 8.70724L10.7073 13.7072C10.3163 14.0982 9.68425 14.0982 9.29325 13.7072L4.29325 8.70724C3.90225 8.31624 3.90225 7.68424 4.29325 7.29324C4.68425 6.90224 5.31625 6.90224 5.70725 7.29324L10.0002 11.5862L14.2933 7.29324C14.6842 6.90224 15.3162 6.90224 15.7072 7.29324C15.9022 7.48824 16.0002 7.74424 16.0002 8.00024Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "fc3d8a6aae06673c14109c5da3fc09c5.svg";
export { ForwardRef as ReactComponent };